export default __webpack_public_path__ + "images/4L.fb75dc0.png";